module.exports = __webpack_public_path__ + "img/coming-soon-Logo.61e0ac83.png";